export default __webpack_public_path__ + "static/media/Musicplayer.f3d5c1e2.png";